import React, {Fragment, useEffect, useState, useRef} from 'react';
import {Card, Loader, Accordion, Section, Date_picker, Text, Select, TextEditor, Form, HtmlTooltip} from '../../../../components';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import QuizzIcon from '@material-ui/icons/Help';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import {Field} from 'react-final-form';
import { FieldArray } from 'react-final-form-arrays';
import arrayMutators from 'final-form-arrays';
import Grid from '@material-ui/core/Grid';
import {connect} from 'react-redux';
import TuneIcon from '@material-ui/icons/Tune';
import Tooltip from '@material-ui/core/Tooltip';
import FactCheckIcon from '@material-ui/icons/PlaylistAddCheck';
import MenuIcon from '@material-ui/icons/Menu'
//QUIZZ FORM;
//<Grid item xs={3} style={{marginBottom:'5px'}}><Field name={`${name}.weight`}>{(f)=>{let pv=(previous_weights.current[id]==undefined)?0:Number(previous_weights.current[id]); console.log(total_weight, f.input.value, pv); if(f.input.value!=pv){setTotalWeight(total_weight+Number(f.input.value) - pv); previous_weights.current[id]=f.input.value;}  return(<Typography style={{marginTop:'10px'}}>{Math.round((f.input.value/total_weight)*10000)/100+'%'}</Typography>)}}</Field></Grid>

function Quizzes(props){
  let step_fields=useRef(undefined);
  const[total_weight, setTotalWeight]=useState(0);
  const[new_index, setNewIndex]=useState(0);
  const [error, setError]=useState(false);
  const [preview_popup, setPreviewPopup]=useState(undefined);
  let first_time=useRef(true);
  let previous_weights=useRef({});

  function onSubmit(params){
    //if(params.name==undefined || params.description==undefined){setError(true); return;}
    //for(let qq of params.quizz_parts){
    //  if(qq.section==true){if(qq.name==undefined){setError(true); return}}
    //  else if(qq.question==undefined || qq.type==undefined){setError(true); return;}
    //}
    if(props.match.params.id==undefined){props.createQuizz(params);}
    else{props.updateQuizz(props.match.params.id, params);}
  }

  function moveCard(dragIndex, hoverIndex){
    let min_index=(dragIndex<=hoverIndex)?dragIndex:hoverIndex;
    let max_index=(hoverIndex>=dragIndex)?hoverIndex:dragIndex

    let new_fields=[];
    let index=0;
    for(let f of step_fields.current.input.value){
      if(index==min_index){new_fields.push(step_fields.current.input.value[max_index]);}
      if(index!=max_index){new_fields.push(f);}
      index+=1;
    }
    step_fields.current.input.onChange(JSON.parse(JSON.stringify(new_fields)));
  }

  useEffect(()=>{
    if(props.short_codes==undefined){props.indexShortCodes();}
    if(props.match.params.id!=undefined && (props.quizzes==undefined || props.quizzes[props.match.params.id]==undefined)){props.getQuizz(props.match.params.id);}
  },[]);
  let initial_values={}; if(props.match.params.id!=undefined && props.quizzes!=undefined && props.quizzes[props.match.params.id]!=undefined){initial_values=props.quizzes[props.match.params.id]; if(first_time.current==true){first_time.current=false; let new_total_weight=0; let quizz_parts=[]; for(let sec of initial_values.quizz_sections){quizz_parts.push({section:true, ...sec}); for(let qq of sec.quizz_questions){quizz_parts.push(qq); qq.weight=qq.weight/100; previous_weights.current[qq.id]=qq.weight; new_total_weight+=qq.weight; if(qq.condition_id!=undefined){qq.question_conditional=true;}}}; initial_values.quizz_parts=quizz_parts; setTotalWeight(new_total_weight);}}
  console.log(initial_values, 'INITIAL VALUES');


  return(
    <Fragment>
    <Section title={(props.match.params.id==undefined)?'New quiz':'Edit quiz'} icon={<QuizzIcon color='primary'/>} action={<Button variant='contained' onClick={()=>{props.history.push('/sales_coach/quizzes')}}>Exit</Button>}>
      <Form
        onSubmit={onSubmit}
        mutators={{
          ...arrayMutators
        }}
        initialValues={initial_values}
        handleClose={()=>{props.history.push('/sales_coach/quizzes')}}
        loader
      >
        {form_props => (
          <form onSubmit={form_props.handleSubmit}>
            {(error==true)?<Typography style={{marginTop:'30px', marginBottom:'30px'}} color='error'>You must fill in all required fields before submitting. (Quizz question explanations are the only optional fields)</Typography>:null}
            <div style={{maxWidth:'400px', width:'100%'}}><Text required title='Name' name='name'/></div>
            <div style={{maxWidth:'400px', width:'100%'}}><Text required title='Description' name='description' rows={3}/></div>
            <Field name='quizz_parts'>{(f)=>{step_fields.current=f; return null}}</Field>
            <FieldArray name='quizz_parts'>
            {({ fields }) =>{
              let past_sections=0;
              let questions=[]; for(let qf of step_fields.current.input.value){if(qf.section==undefined){questions.push(qf);}}
              return(
              <Fragment>
              <Typography color='primary' style={{marginTop:'30px', marginBottom:'30px'}}><span><FactCheckIcon color='primary' style={{position:'absolute', left:'20px'}}/></span><span style={{marginLeft:'40px'}}>Questions</span>{(initial_values==undefined || initial_values.brier_skill_score==undefined)?null:<span style={{marginLeft:'20px'}}>{' BSS:'+Math.floor(initial_values.brier_skill_score/100)+'%'}</span>}<Button variant='contained' color='primary' style={{position:'absolute', right:'10px', cursor:'pointer'}} onClick={()=>{fields.push({internal_id:'js_'+new_index, section:true}, undefined); setNewIndex(new_index+1)}}>New section</Button><AddIcon color='secondary' style={{position:'absolute', right:'160px', cursor:'pointer'}} onClick={()=>{fields.push({internal_id:'js_'+new_index, weight:(fields.value==undefined)?10:total_weight/questions.length}, undefined); setNewIndex(new_index+1)}}/></Typography>
              {fields.map((name, index) => {
                let card=fields.value[index];
                let id=fields.value[index].id;
                if(id==undefined){id=fields.value[index].internal_id;}
                let select_condition=[];
                let iindex=1; for(let fv of fields.value){let iid=(fv.id==undefined)?fv.internal_id:fv.id; if(iid==id){break;}else if(fv.type==0){select_condition.push({id:iid, name:iindex+')'+fv.question});}if(fv.section!=true){iindex+=1;}}
                if(card.section==true){
                  past_sections+=1;
                  return (
                    <Card
                      key={(card.id==undefined)?card.internal_id:card.id}
                      index={index}
                      id={(card.id==undefined)?card.internal_id:card.id}
                      moveCard={moveCard}
                      text={<Grid container style={{width:'100%', marginTop:'20px', marginBottom:'20px', width:'100%'}}><Grid item xs={1} style={{position:'relative'}}><MenuIcon style={{cursor:'move', fontSize:'15px', position:'absolute', top:'20px', left:'5px'}}/></Grid><Grid item xs={8}><Text required  title='Section name' name={`${name}.name`}/></Grid><Grid item xs={3} style={{position:'relative'}}><DeleteIcon color='secondary' style={{position:'absolute', cursor:'pointer', top:'10px', right:'55px'}} onClick={(e)=>{let new_fields=[]; let i=0; for(let sf of step_fields.current.input.value){if(i!=index){new_fields.push(sf);}; i+=1;}; step_fields.current.input.onChange([]); window.setTimeout(function(){step_fields.current.input.onChange(new_fields);}, 1); e.stopPropagation()}}/></Grid></Grid>}/>
                  )
                }
                let title_index=index-past_sections+1;
                return(
                  <Card
                    key={(card.id==undefined)?card.internal_id:card.id}
                    index={index}
                    id={(card.id==undefined)?card.internal_id:card.id}
                    moveCard={moveCard}
                    text={
                      <Fragment>
                        <hr style={{width:'100%', marginTop:'0px', marginBottom:'0px'}}/>
                        <Accordion  content={[{title:
                          <Typography style={{marginLeft:'10px', marginBottom:'0px', position:'relative', width:'calc(100% - 130px)'}} color='primary' ><MenuIcon style={{position:'absolute', left:'-25px', cursor:'move', top:'3px', fontSize:'15px'}}/><Field name={`${name}.negative_weighting`}>{(fqn)=><Field name={`${name}.positive_weighting`}>{(fq)=><Fragment><Field name={`${name}.question`}>{(f)=><Field name={`${name}.explanation`}>{(ff)=><HtmlTooltip title={ff.input.value}><span style={{maxWidth:'calc(100% - 0px)', overflow:'hidden'}}>{title_index+')  '}<span style={{color:'rgba(0, 0, 0, 0.87)'}}>{f.input.value}</span></span></HtmlTooltip>}</Field>}</Field>
                          <Tooltip title={'Positive W: '+((fq.input.value=='')?'...':Math.round(fq.input.value/100))+'%, Negative W: '+((fqn.input.value=='')?'...':Math.round(fqn.input.value/100))+'%'}>
                          <Typography style={{position:'absolute', right:'-90px', top:'0px'}}>
                          ({(fq.input.value=='')?'...':(Math.round(fq.input.value/100))}<span>/</span>{(fqn.input.value=='')?'...':(-Math.round(fqn.input.value/100))}
                        )</Typography>
                          </Tooltip>
                          <DeleteIcon color='secondary' style={{position:'absolute', right:'-120px', top:'0px', cursor:'pointer'}} onClick={(e)=>{setTotalWeight(total_weight - previous_weights.current[id]); let new_fields=[]; let i=0; for(let sf of step_fields.current.input.value){if(i!=index){new_fields.push(sf);}; i+=1;}; step_fields.current.input.onChange([]); window.setTimeout(function(){step_fields.current.input.onChange(new_fields);}, 1);
                          //setTotalNegativeWeight(total_negative_weight - previous_negative_weights.current[id]);
                          e.stopPropagation()}}/></Fragment>}</Field>}</Field></Typography>
                        ,
                        content:
                          <Grid container style={{marginBottom:'20px'}}>
                          <Grid item xs={12} sm={6}>
                          <Grid container>
                            <Grid item xs={12} style={{marginBottom:'5px'}}><Text required  multiline rows={3} title='Question' name={`${name}.question`}/></Grid>
                          </Grid>
                          </Grid>
                          <Grid item xs={12} sm={6}>
                          <Grid container>
                            <Grid item xs={9} style={{marginBottom:'10px', marginTop:'8px'}}><Select required title='Type' name={`${name}.type`} select_data={[{id:0, name:'Yes - No - Maybe'}, {id:1, name:'1 to 5'}, {id:2, name:'Evidence based qualification'}, {id:3, name:'Likert scale (disagree - agree)'}]}/></Grid>
                            {(select_condition.length==0)?null:<Grid item xs={12}><Field name={`${name}.question_conditional`}>{(f)=>{return(<FormControlLabel control={<Checkbox style={{marginLeft:'10px'}} checked={f.input.value} onChange={f.input.onChange} name={`${name}.question_conditional`} color="primary"/>} label="Make conditional"/>)}}</Field></Grid>}
                            <Field name={`${name}.question_conditional`}>{(f)=>{return(<Fragment>{(f.input.value==false || select_condition.length==0)?null:<Fragment>
                              <Grid item xs={12}><Typography style={{marginLeft:'15px'}} variant='caption'>Only display this question if you received the following answer to the following question:</Typography></Grid>
                              <Grid item xs={6} style={{marginBottom:'5px'}}><Select name={`${name}.condition_answer`} select_data={[{id:100, name:'Yes'}, {id:50, name:'Maybe'}, {id:0, name:'No'}]}/></Grid>
                              <Grid item xs={6} style={{marginBottom:'5px'}}><Select name={`${name}.condition_id`} select_data={select_condition}/></Grid>
                          </Fragment>}</Fragment>)}}</Field>
                          </Grid>
                          </Grid>
                          <Grid item xs={12} style={{marginBottom:'5px'}}><Field name={`${name}.explanation`}>{(f)=><div style={{width:'calc(100%-30px)', marginLeft:'10px', marginTop:'10px', marginBottom:'10px'}}><TextEditor block_short_codes={true} required title='Description' value={f.input.value} onChange={f.input.onChange}/></div>}</Field></Grid>
                          <Field name={`${name}.type`}>{(f)=>(f.input.value!=2)?null:<Fragment>
                          <Grid item xs={12}><Text multiline rows={2} title='1. Observable evidence' name={`${name}.quizz_question_evidence_based.evidence_1`}/></Grid>
                          <Grid item xs={12}><Text multiline rows={2} title='2. Observable evidence' name={`${name}.quizz_question_evidence_based.evidence_2`}/></Grid>
                          <Grid item xs={12}><Text multiline rows={2} title='3. Observable evidence' name={`${name}.quizz_question_evidence_based.evidence_3`}/></Grid>
                          <Grid item xs={12}><Text multiline rows={2} title='4. Observable evidence' name={`${name}.quizz_question_evidence_based.evidence_4`}/></Grid>
                          <Grid item xs={12}><Text multiline rows={2} title='5. Observable evidence' name={`${name}.quizz_question_evidence_based.evidence_5`}/></Grid>
                          </Fragment>}</Field>
                          </Grid>
                        }]}/>
                      </Fragment>
                    }/>
              )})}
              <div style={{marginTop:'30px', width:'100%', position:'relative', display:'flex', justifyContent:'center', alignItems:'center'}}><Button color='primary' variant='contained' onClick={()=>{form_props.form.submit();}}>Save</Button></div>
              </Fragment>)}
            }</FieldArray>
          </form>
        )}
      </Form>
    </Section>
    <div style={{height:'30px'}}/>
    </Fragment>
  );
}





export default connect(ss, dd)(Quizzes);

function ss(state){
  return{
    quizzes:state.sales_coach.quizzes,
    short_codes:state.templates.short_codes
  }
}

function dd(dispatch){
  return{
    getQuizz:(id)=>{dispatch({type:'REQUEST_GET_QUIZZ', id:id})},
    createQuizz:(data)=>{dispatch({type:'REQUEST_CREATE_QUIZZ', payload:data})},
    updateQuizz:(id, data)=>{dispatch({type:'REQUEST_UPDATE_QUIZZ', id:id, payload:data})},
    indexShortCodes:()=>{dispatch({type:'REQUEST_INDEX_SHORT_CODES'});}
  }
}
